/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionDefinitionSetStateRequest {
    getFixupPrototypeFunction() { return DimensionDefinitionSetStateRequest.fixupPrototype; }

    static newInstance(model: Partial<DimensionDefinitionSetStateRequest>): DimensionDefinitionSetStateRequest {
        let obj = Object.assign(new DimensionDefinitionSetStateRequest(), model);
        DimensionDefinitionSetStateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionDefinitionSetStateRequest>): DimensionDefinitionSetStateRequest {
        if (!model) return null;
        return DimensionDefinitionSetStateRequest.newInstance(<DimensionDefinitionSetStateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionDefinitionSetStateRequest) {
        if (!obj) return;

        models.DimensionDefinitionSetStateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionDefinitionSetStateRequest): boolean {
        Object.setPrototypeOf(obj, DimensionDefinitionSetStateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * States if the Dimension Definition is active or not
     */
    is_active: boolean;

    /**
     * Name of the Dimension Definition
     */
    name: string;

    /**
     * Description of Dimension Definition
     */
    description: string;

    /**
     * If True, Cost Anomaly Detection will be enabled for all grouping rules under this Dimension
     */
    is_cost_anomaly_detection_enabled: boolean = false;

}
